import { Component, computed, ElementRef, signal, Signal, ViewChild, WritableSignal } from '@angular/core';
import { ParticipantModel } from '@shared/models/participant.model';
import { I18nService } from '@app/i18n';
import { ParticipantService } from '@shared/services/participant/participant.service';
import { PlIcon } from '@app/icon-library/icons';
import { AuthenticationService } from '@app/auth';
import { PlRouter } from '@shared/services/pl-router.service';
import { getRoutePath, PlRoute } from '@app/utils/routes';
import { ProfileTabs, queryParamKeyTab } from '@app/profile/profile.component';
import { Params } from '@angular/router';
import { PositionX, PositionY } from '../pl-popover/pl-popover.component';
import { opacityAnimation } from '@app/utils/animations';

interface MenuItem {
  label: string;
  link: string;
  queryParams?: Params;
}

@Component({
  selector: 'pl-menu-button-profile',
  templateUrl: './menuButtonProfile.component.html',
  animations: [opacityAnimation],
})
export class MenuButtonProfileComponent {
  public menuItems: MenuItem[] = this.getMenuItems();

  public participantFullName: Signal<string> = computed(() => this.getFullName(this.participantService.participant()));
  public participantInitials: Signal<string> = computed(() => this.getInitials(this.participantService.participant()));

  public readonly PlIcon: typeof PlIcon = PlIcon;
  public readonly PositionX: typeof PositionX = PositionX;
  public readonly PositionY: typeof PositionY = PositionY;

  @ViewChild('buttonToLinkPopover') public buttonToLinkPopover!: ElementRef;
  public showMenu: WritableSignal<boolean> = signal(false);

  constructor(
    private i18nService: I18nService,
    private plRouter: PlRouter,
    private authenticationService: AuthenticationService,
    private participantService: ParticipantService,
  ) {}

  private getFullName(participant: ParticipantModel | null): string {
    if (participant) {
      return `${participant.first_name} ${participant.last_name}`;
    }
    return '';
  }

  private getInitials(participant: ParticipantModel | null): string {
    if (participant) {
      return `${participant.first_name.length > 0 ? participant.first_name[0] : ''}${
        participant.last_name.length > 0 ? participant.last_name[0] : ''
      }`;
    }
    return '';
  }

  private getMenuItems(): MenuItem[] {
    return [
      {
        label: this.i18nService.translate('profile.personal_details'),
        link: getRoutePath(PlRoute.profile),
        queryParams: { [queryParamKeyTab]: ProfileTabs.details },
      },
      {
        label: this.i18nService.translate('profile.360_survey'),
        link: getRoutePath(PlRoute.profile),
        queryParams: { [queryParamKeyTab]: ProfileTabs.survey360 },
      },
      {
        label: this.i18nService.translate('profile.certificates.tab_title'),
        link: getRoutePath(PlRoute.profile),
        queryParams: { [queryParamKeyTab]: ProfileTabs.certificates },
      },
      {
        label: this.i18nService.translate('profile.weekly_lifeacts.title'),
        link: getRoutePath(PlRoute.lifeActs),
      },
      {
        label: this.i18nService.translate('profile.lifechanges'),
        link: getRoutePath(PlRoute.lifeChanges),
      },
    ];
  }

  public onMenuItemClicked(item: MenuItem, event: MouseEvent): void {
    this.closeMenu();

    console.log('TONIO MenuButtonProfileComponent onMenuItemClicked link=', item.link);
    this.plRouter.navigate(
      [item.link],
      {
        queryParams: item.queryParams,
      },
      event,
    );
  }

  public logout(): void {
    this.authenticationService.logout();
  }

  public closeMenu(): void {
    console.log('TONIO MenuButtonProfileComponent closeMenu =');
    this.showMenu.set(false);
  }

  public openMenu(): void {
    console.log('TONIO MenuButtonProfileComponent openMenu =');
    this.showMenu.set(true);
  }
}
